import { Action } from 'redux'

import { BonusPeriodInfoDto } from '../model'

export const SET_SELECTED_USER_ACTIVE_BONUS_PERIOD = '[bonus-period] Set active bonus period for selected user'
export class SetSelectedUserActiveBonusPeriodAction implements Action {
  readonly type = SET_SELECTED_USER_ACTIVE_BONUS_PERIOD
  constructor(public activeBonusPeriod: BonusPeriodInfoDto, public bonusPeriods: BonusPeriodInfoDto[]) {}
}

export const SET_ACTIVE_BONUS_PERIOD = '[bonus-period] Set active bonus period'
export class SetActiveBonusPeriodAction implements Action {
  readonly type = SET_ACTIVE_BONUS_PERIOD
  constructor(public activeBonusPeriod: BonusPeriodInfoDto, public bonusPeriods: BonusPeriodInfoDto[]) {}
}

type BonusPeriodActions = SetActiveBonusPeriodAction | SetSelectedUserActiveBonusPeriodAction
export default BonusPeriodActions



// WEBPACK FOOTER //
// ./src/app/shared/store/bonusperiod.actions.ts